$(document).ready(function () {
  var $infoSections = $(".info-section");

  if ((window.Shopify && window.Shopify.designMode) || !("IntersectionObserver" in window)) {
    $infoSections.addClass("is-visible");
  } else {
    var infoObserver = new IntersectionObserver(function (entries) {
      $.each(entries, function (i, entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("is-visible");
          infoObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -80px 0px" });

    $infoSections.each(function () {
      infoObserver.observe(this);
    });
  }

  $(document).on("shopify:section:load", function (e) {
    $(e.target).find(".info-section").addClass("is-visible");
  });

  $(document).on("click", ".info-films__chip", function () {
    var $chip = $(this);
    var $section = $chip.closest(".info-films");
    var group = String($chip.data("group"));

    $section.find(".info-films__chip").removeClass("is-active");
    $chip.addClass("is-active");

    if (group === "all") {
      $section.find(".info-films__group").removeClass("is-hidden");
    } else {
      $section.find(".info-films__group").addClass("is-hidden");
      $section.find('.info-films__group[data-group="' + group + '"]').removeClass("is-hidden");
    }
  });

  $(document).on("click", ".info-faq__summary", function (e) {
    e.preventDefault();
    var $item = $(this).closest(".info-faq__item");
    var $answer = $item.find(".info-faq__answer");

    if ($item.hasClass("is-open")) {
      $item.removeClass("is-open");
      $answer.stop(true).slideUp(300, function () {
        $item.removeAttr("open");
        $answer.css("display", "");
      });
    } else {
      $item.addClass("is-open").attr("open", "");
      $answer.stop(true).hide().slideDown(300);
    }
  });

  function updateInquiryConditions($form) {
    var chosen = [];

    $form.find(".info-inquiry__choice:checked").each(function () {
      chosen.push($.trim($(this).siblings(".info-inquiry__choice-text").text()));
    });

    $form.find("[data-show-when]").each(function () {
      var $row = $(this);
      var rule = String($row.attr("data-show-when"));
      var values = rule.indexOf("|") !== -1 ? rule.split("|") : rule.split(",");
      var show = false;

      $.each(values, function (i, value) {
        if ($.inArray($.trim(value), chosen) !== -1) {
          show = true;
        }
      });

      $row.toggleClass("is-hidden", !show);
      $row.find("input, textarea").prop("disabled", !show);
    });
  }

  function updateInquiryRoute($form) {
    var $input = $form.find("[data-route-input]");
    var $tags = $form.find("[data-route-tags]");
    var email = $input.attr("data-route-default") || "";
    var matched = "";

    if (!$input.length) {
      return;
    }

    $form.find(".info-inquiry__choice:checked").each(function () {
      var choice = $.trim($(this).siblings(".info-inquiry__choice-text").text());

      $form.find("[data-route-option]").each(function () {
        if (!matched && $(this).attr("data-route-option") === choice && $(this).attr("data-route-email")) {
          matched = choice;
          email = $(this).attr("data-route-email");
        }
      });
    });

    $input.val(email);
    $tags.val(matched ? $tags.attr("data-route-tags") + ", " + matched : $tags.attr("data-route-tags"));
  }

  $(".info-inquiry__form").each(function () {
    updateInquiryConditions($(this));
    updateInquiryRoute($(this));
  });

  $(document).on("change", ".info-inquiry__choice", function () {
    var $form = $(this).closest("form");
    updateInquiryConditions($form);
    updateInquiryRoute($form);
  });

  $(document).on("input", ".info-inquiry__textarea", function () {
    this.style.height = "auto";
    this.style.height = this.scrollHeight + "px";
  });

  $(document).on("click", ".info-media__play", function () {
    var $media = $(this).closest(".info-media");
    var video = $media.find(".info-media__video").get(0);

    if (!video) {
      return;
    }

    $(".info-media__video").each(function () {
      if (this !== video) {
        this.pause();
      }
    });

    $media.addClass("is-playing");
    video.controls = true;
    video.play();
  });
});
